import React, { useState, useEffect, useCallback } from "react";
import { Loader, Message, Icon, Modal } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import { Assistant_createthread } from "../../../../api/AssistantEducaAPI";
import { AssistantEducaChat } from "../../../AssistantEduca";
import "./AssistantStudent.scss";

const didacticRoutesAPI = new DidacticRoutesAPI();

export function AssistantStudent({ routeId, accessToken }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [assistants, setAssistants] = useState([]);

  // =========== Estado para el Chat ===========
  // Guardamos el assistant sobre el que se va a chatear
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [threadId, setThreadId] = useState(null);

  // Función para cargar la ruta y extraer asistentes
  const fetchAssistants = useCallback(async () => {
    if (!routeId) return;
    try {
      setLoading(true);
      setError(null);

      // 1. Obtener la ruta
      const routeRes = await didacticRoutesAPI.getRouteById(accessToken, routeId);
      const routeData = routeRes.route;
      if (!routeData) {
        setError("No se encontró la ruta");
        return;
      }

      // 2. Extraer la lista de asistentes
      // routeData.assistants suele ser un array de objetos { assistant: {...} }
      if (Array.isArray(routeData.assistants) && routeData.assistants.length > 0) {
        // Mapeamos para quedarnos con el objeto "assistant" completo
        const newAssistants = routeData.assistants.map((a) => a.assistant);
        setAssistants(newAssistants);
      } else {
        // No hay asistentes
        setAssistants([]);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || "Error desconocido");
    } finally {
      setLoading(false);
    }
  }, [routeId, accessToken]);

  useEffect(() => {
    fetchAssistants();
  }, [fetchAssistants]);

  // =====================================
  // Manejo del Chat (similar a AssistanceItem)
  // =====================================
  const handleOpenChat = async (assistant) => {
    try {
      // Si no tenemos threadId o cambiamos de assistant, creamos un nuevo thread
      if (!showChat || selectedAssistant?._id !== assistant._id) {
        // Llamada a la API para crear/obtener thread
        const newThreadId = await Assistant_createthread(accessToken, assistant._id);
        console.log("newThreadId obtenido:", newThreadId);
        setThreadId(newThreadId);
        setSelectedAssistant(assistant);
      }

      // Abrimos el modal de chat
      setShowChat(true);
    } catch (error) {
      console.error("Error al crear el thread:", error);
    }
  };

  const handleCloseChat = () => {
    // Cierra el modal
    setShowChat(false);
  };

  // ===================== Render principal =====================
  if (!routeId) {
    return <p>Selecciona una ruta para ver los asistentes virtuales.</p>;
  }

  if (loading) {
    return <Loader active inline="centered">Cargando asistentes...</Loader>;
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>Error al cargar asistentes</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  if (assistants.length === 0) {
    return (
      <Message info>
        <Message.Header>Sin asistentes</Message.Header>
        <p>Esta ruta no tiene asistentes virtuales asignados.</p>
      </Message>
    );
  }

  return (
    <div className="assistant-student">
      {/* Mapeamos cada asistente como tarjeta */}
      {assistants.map((asst) => (
        <div key={asst._id} className="e-card-assistance">
          <div className="assistance-info">
            <h3 className="assistance-title">{asst.title}</h3>
            <p className="assistance-center">Asistente Virtual</p>

            <div className="assistance-buttons">
              {/* Botón de chat */}
              <button
                className="e-button-chat"
                onClick={() => handleOpenChat(asst)}
              >
                <Icon name="comments" />
              </button>
            </div>
          </div>

          <div className="assistance-image">
            <img src={asst.miniature} alt={asst.title} />
          </div>
        </div>
      ))}

      {/* Modal de chat */}
      <Modal
        open={showChat}
        onClose={handleCloseChat}
        closeIcon
        size="small"
        className="chatbot-modal"
      >
        <Modal.Content scrolling>
          {/* 
            Si tenemos assistant seleccionado, mostramos el chat
            con su threadId y demás props 
          */}
          {selectedAssistant && (
            <AssistantEducaChat
              assistantId={selectedAssistant._id}
              avatarImg={selectedAssistant.miniature}
              saludo={selectedAssistant.title}
              threadId={threadId}
            />
          )}
        </Modal.Content>
      </Modal>
    </div>
  );
}
